export const INDUSTRIES: string[] = [
  'Full Service Restaurant',
  'Quick Service Restaurant',
  'Bowling Alley',
  'Car Service',
  'Entertainment & Events',
  'Health Care',
  'Hotels',
  'Personal Services',
  'Pharmacy',
  'Poker & Casinos',
  'Retail',
  'Transportation & Logistics',
  'Other'
];
